import React from "react";

export default function StopLimitIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
      <rect width="32" height="32" rx="16" fill="#002035" />
      <path
        d="M8 16.6675L10.5 11L17.9152 22.5L21.4545 17.3405L24 22.1475"
        stroke="#FEDBDB"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M9 21C12.3696 21 12.2292 21 11.7378 21"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M15 21C18.3696 21 18.2292 21 17.7378 21"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M21 21C24.3696 21 24.2292 21 23.7378 21"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M20.03 10.1304H18.017C17.6573 10.1201 17.3203 10.296 17.1373 10.5894C16.9542 10.8829 16.9542 11.2474 17.1373 11.5408C17.3203 11.8343 17.6573 12.0101 18.017 11.9998H19.023C19.3826 11.9895 19.7197 12.1654 19.9027 12.4588C20.0857 12.7522 20.0857 13.1168 19.9027 13.4102C19.7197 13.7037 19.3826 13.8795 19.023 13.8692H17.01"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.5198 9V10.1305"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.5198 13.8694V15"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
